/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {SalesTerritoryAssignmentVoModel} from './sales-territory-assignment-vo.model';

export class TerritorySalesListVoModel extends JSONable {
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  salesAssignmentVOs: SalesTerritoryAssignmentVoModel[] | undefined = undefined;
}
